import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "offcanvas__area offcanvas__2" }
const _hoisted_2 = { class: "offcanvas__wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"offcanvas__close\"><button class=\"offcanvas__close-btn offcanvas-close-btn\"><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 1L1 11\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M1 1L11 11\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></button></div>", 1)
const _hoisted_4 = { class: "offcanvas__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "offcanvas__top mb-90 d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "offcanvas__logo tp-header-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/lms_website/images/unix_logo-sm.jpg",
      alt: "logo"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "offcanvas-main" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tp-main-menu-mobile d-xxl-none" }, null, -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "row mt-2 mb-4"
}
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-user-plus mr-1" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "col-12 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-sign-in mr-1" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "offcanvas-social" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "offcanvas-title sm" }, "Follow Us", -1 /* HOISTED */)
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-facebook-f" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-tiktok" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-twitter" }, null, -1 /* HOISTED */)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-linkedin-in" }, null, -1 /* HOISTED */)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-youtube" }, null, -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "body-overlay" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Body = _resolveComponent("Body")
  const _component_Header = _resolveComponent("Header")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Body),
    _createVNode(_component_Header),
    _createCommentVNode(" offcanvas area start "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (!$setup.isLoggedIn())
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      class: "btn btn-dark text-center w-100",
                      to: {name:'student_applicant'}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Student Applicant')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      class: "tp-btn-inner text-center w-100",
                      to: { name: 'auth.login' , query: { redirect: _ctx.$route.fullPath }}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Log In')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  ($setup.lms_website.settings_list.facebook_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.facebook_link,
                        target: "_blank"
                      }, _hoisted_17, 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("li", null, [
                  ($setup.lms_website.settings_list.tiktok_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.tiktok_link,
                        target: "_blank"
                      }, _hoisted_20, 8 /* PROPS */, _hoisted_18))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("li", null, [
                  ($setup.lms_website.settings_list.twitter_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.twitter_link,
                        target: "_blank"
                      }, _hoisted_23, 8 /* PROPS */, _hoisted_21))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("li", null, [
                  ($setup.lms_website.settings_list.linkedin_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.linkedin_link,
                        target: "_blank"
                      }, _hoisted_26, 8 /* PROPS */, _hoisted_24))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("li", null, [
                  ($setup.lms_website.settings_list.youtube_link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $setup.lms_website.settings_list.youtube_link,
                        target: "_blank"
                      }, _hoisted_29, 8 /* PROPS */, _hoisted_27))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_30,
    _createCommentVNode(" offcanvas area end "),
    _createCommentVNode(" for example router view "),
    _createVNode(_component_router_view),
    _createCommentVNode(" set progressbar "),
    _createVNode(_component_Footer)
  ], 64 /* STABLE_FRAGMENT */))
}